import { toast } from "sonner";
import { getAuthUrlWithRedirect } from "@/utils/authRedirect";

/**
 * Exibe um toast de "Login necessário" com botão de ação
 * Redireciona para /auth com parâmetro de retorno
 * Uso: toastLoginRequired("Faça login para avaliar")
 */
export function toastLoginRequired(description: string) {
  toast("Login necessário", {
    description,
    action: {
      label: "Entrar",
      onClick: () => {
        window.location.href = getAuthUrlWithRedirect();
      },
    },
    duration: 8000,
  });
}
